// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__Laq_m","label":"LabeledBox_label__1ynMa"};